import { Component, OnInit, OnDestroy } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';


@Component({
    selector: 'jhi-legal',
    templateUrl: './legal.component.html'
})
export class LegalComponent implements OnInit {

    constructor(
        private jhiLanguageService: JhiLanguageService
    ) {
        this.jhiLanguageService.setLocations(['legal']);
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal/legal.component.ts